module.exports = __webpack_public_path__ + "media/images/empty-page-e620eec3c286c7fd55cb9c7e6e7d2ca7.png";